export enum TipoConsulta{
    ClasificarSolicitud = 10,
    AutorizacionesAutomaticas = 12,
    CiudadesProcedimiento = 15
}


// WEBPACK FOOTER //
// /app/src/app/shared/enumeration/tipo-consulta.enum.ts